import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionsContainer from '../QuestionsContainer';
import QuestionnaireNavigationButtons from '../QuestionnaireNavigationButtons';
import { analyticsTrack } from '../../../analyticsUtils';
import { getRequest } from '../../../requestUtils';
import './Questionnaire.scss';
import '../../ConsultantOnboarding/Finish/Finish.scss';

const flatten = (arr) => arr.reduce((flat, next) => flat.concat(next), []);

const getSteps = (object) => {
  const flattened = flatten(Object.values(object));

  const steps = flattened.reduce((filtered, option) => {
    if (!filtered.includes(option.category)) {
      filtered.push(option.category);
    }

    return filtered;
  }, []);
  return steps;
};

const questionHeader = [
  { header: 'About', text: 'Clora sends you projects that align with your level of experience' },
  { header: 'Past Experience', text: 'Your past experience is one of the most important criteria that employers review when they evaluate candidates.' },
  { header: 'Education', text: 'Clora sends you projects that align with the degrees you hold' },
  { header: 'Functional Areas', text: 'Matching functional areas is one of the primary ways we refine project suggestions for you' },
  { header: 'Therapeutic Areas', text: 'We improve project suggestions by leveraging therapeutic areas' },
  { header: 'Industries and Product Technologies', text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions" },
  { header: 'Preferences', text: "Clora's technology will leverage industries, phases, and product types to further enrich your project suggestions" },
];

class Questionnaire extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: parseInt(props.page, 10) || 0,
      finish: props.finish || false,
      percentage: null,
      questionnaireLoaded: false,
    };

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.renderQuestionOrFinish = this.renderQuestionOrFinish.bind(this);
    this.handleUpdatePage = this.handleUpdatePage.bind(this);
    this.loadButtons = this.loadButtons.bind(this);
  }

  componentDidMount() {
    this.updateCompletionPercentage();
    window.questionsContainer = this;
  }

  componentDidUpdate(prevProps) {
    const { page } = this.props;
    this.handleUpdatePage(page, prevProps.page);
  }

  handleUpdatePage(page, prevPage) {
    if (page !== prevPage) {
      this.setState({ currentPage: page, questionnaireLoaded: false });
    }
  }

  handleShowFinishModal(questionKey) {
    const { questionnaireName, handleShowFinishPage } = this.props;
    this.updateCompletionPercentage();
    handleShowFinishPage(true);
    analyticsTrack('Clicked on Save & Exit', {
      location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
      question: questionKey,
    });
  }

  previousPage(questionKey, position) {
    const {
      userId, questionnaireName, handlePreviousStep, setPreviousState,
    } = this.props;
    let { currentPage, finish } = this.state;

    analyticsTrack('Clicked on Previous', {
      location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
      question: questionKey,
      step: questionHeader[currentPage].header,
      position,
      userId,
    });
    if (currentPage === 0) {
      setPreviousState();
      handlePreviousStep();
    } else if (currentPage > 0) {
      currentPage -= 1;
      finish = false;
      handlePreviousStep();
    }
    this.setState({ currentPage, finish });

    window.scrollTo(0, 0);
  }

  nextPage(questionKey, position) {
    let { currentPage, finish } = this.state;
    const {
      userId, questionnaire, questionnaireName,
      handleNextStep, handleShowFinishPage,
    } = this.props;

    if (currentPage !== questionnaire.length - 1) {
      currentPage += 1;
      handleNextStep();
    } else {
      finish = true;
      handleShowFinishPage(true);
    }

    this.setState({ currentPage, finish });
    window.scrollTo(0, 0);
    analyticsTrack('Clicked on Next', {
      location: questionnaireName === 'Consultant Onboarding' ? 'Onboarding Flow' : questionnaireName,
      question: questionKey,
      step: finish ? questionHeader[currentPage].header : questionHeader[currentPage - 1].header,
      position,
      userId,
    });
  }

  updateCompletionPercentage() {
    const { profileQuestionnaireId, userId } = this.props;
    getRequest(
      `/users/${userId}/completion_percentage?questionnaire_id=${profileQuestionnaireId}`,
    ).then((response) => {
      this.setState({ percentage: response.data.value });
    });
  }

  loadButtons() {
    this.setState({ questionnaireLoaded: true });
  }

  renderNavigationButtons(questionKey, position) {
    const { currentPage, finish } = this.state;
    const { questionnaire, onboardType } = this.props;
    return (
      <QuestionnaireNavigationButtons
        steps={getSteps(questionnaire)}
        activeStep={(questionnaire[currentPage] && questionnaire[currentPage][0].category) || 'Next'}
        lastStep={currentPage === 6}
        atBeginning={currentPage === 0}
        finish={finish}
        handleNextStep={() => this.nextPage(questionKey, position)}
        handlePreviousStep={() => this.previousPage(questionKey, position)}
        workflow={onboardType}
        position={position}
      />
    );
  }

  renderQuestionOrFinish() {
    const { currentPage, questionnaireLoaded } = this.state;
    const {
      questionnaire,
      questionnaireName,
      questionableId,
      questionableType,
      csrfToken,
      owner,
      suggestedAnswers,
      userId,
      updateMenu,
      handleMenuUpdate,
    } = this.props;
    const questionnaireQuestionIds = questionnaire[currentPage].map((x) => x.id);
    const categoryName = questionnaire[currentPage][0].category;
    const questionKey = questionnaire[currentPage][0].question_key;
    return (
      <div key={currentPage}>
        <div className="questionnaire-nav">
          <div className="questionnaire-nav-container">
            <div>
              <h5 className="category-name">{questionHeader[currentPage].header}</h5>
              <div className="header-subtext">{questionHeader[currentPage].text}</div>
            </div>
            {this.renderNavigationButtons(questionKey, 'top')}
          </div>
        </div>
        <QuestionsContainer
          questionnaireName={questionnaireName}
          questionIds={categoryName === 'Education' ? [questionnaireQuestionIds[0]] : questionnaireQuestionIds}
          questionableId={questionableId}
          questionableType={questionableType}
          csrfToken={csrfToken}
          owner={owner}
          userId={userId}
          suggestedAnswers={suggestedAnswers}
          saveOnChange
          updateMenu={updateMenu}
          handleMenuUpdate={handleMenuUpdate}
          questionHeader={questionHeader[currentPage].header}
          loadButtons={this.loadButtons}
        />
        {questionnaireLoaded && this.renderNavigationButtons(questionKey, 'bottom')}
      </div>
    );
  }

  render() {
    return (
      <div className="main-container">
        {this.renderQuestionOrFinish()}
      </div>
    );
  }
}

Questionnaire.propTypes = {
  questionnaireName: PropTypes.string.isRequired,
  questionnaire: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  owner: PropTypes.bool,
  onboardType: PropTypes.string.isRequired,
  page: PropTypes.number,
  suggestedAnswers: PropTypes.shape({}),
  finish: PropTypes.bool,
  userId: PropTypes.string,
  profileQuestionnaireId: PropTypes.number,
  handleNextStep: PropTypes.func.isRequired,
  setPreviousState: PropTypes.func.isRequired,
  handlePreviousStep: PropTypes.func.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleShowFinishPage: PropTypes.func.isRequired,
};

Questionnaire.defaultProps = {
  page: null,
  owner: false,
  suggestedAnswers: null,
  finish: false,
  userId: null,
  profileQuestionnaireId: null,
};

export default Questionnaire;
